import { render } from "./Meta.vue?vue&type=template&id=b1c02d18&ts=true"
import script from "./Meta.vue?vue&type=script&lang=ts"
export * from "./Meta.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__